import React, { ReactNode } from 'react';
import { Page } from '../AppRouter';
import TopNavigation from './TopNavigation';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
  currentPage: Page;
  onPageChange: (page: Page) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, currentPage, onPageChange }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <Header />

      {/* Top Navigation */}
      <TopNavigation currentPage={currentPage} onPageChange={onPageChange} />

      {/* Page Content */}
      <main className="flex-1 p-4 md:p-6">
        {children}
      </main>
    </div>
  );
};

export default Layout;